module.exports = __webpack_public_path__ + "static/media/hushdream-4.1be9dc5c.jpg";